import React, { useEffect, useState } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/testimonials';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [purchase, setPurchase] = useState(recentPurchases[0]);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    let cycleTimer: number | undefined;
    const show = () => {
      setPurchase(recentPurchases[Math.floor(Math.random() * recentPurchases.length)]);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        cycleTimer = window.setTimeout(show, 28000 + Math.floor(Math.random() * 14000));
      }, 5000);
    };
    const initialTimer = window.setTimeout(show, 15000);
    return () => {
      window.clearTimeout(initialTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <aside aria-live="polite" className={`fixed bottom-4 left-4 z-50 w-[calc(100%-2rem)] max-w-sm transition-[transform,opacity] duration-300 ease-out ${visible ? 'translate-x-0 opacity-100' : 'pointer-events-none -translate-x-[120%] opacity-0'}`} data-id="element-176" data-mp="117fobwkmljop">
      <div className="relative border border-line bg-white p-4 pr-10 shadow-[0_16px_40px_rgba(43,41,37,.14)]" data-id="element-177" data-mp="1az20bv4sfmsi">
        <button type="button" aria-label="Dismiss recent purchase notification" onClick={() => setDismissed(true)} className="absolute right-2 top-2 p-1 text-stone-500 transition-colors duration-150 ease-out hover:text-ink-900" data-id="element-178" data-mp="i8a6337a987t">
          <XIcon className="h-4 w-4" data-id="element-179" data-mp="s8kkus8yunp3" />
        </button>
        <p className="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[.18em] text-sage-700" data-id="element-180" data-mp="28jeuikng55f1">
          <span className="grid h-4 w-4 place-items-center rounded-full bg-sage-600" data-id="element-181" data-mp="23kv3i5tzx3ft">
            <CheckIcon className="h-3 w-3 text-white" data-id="element-182" data-mp="2anrur3odj6gw" />
          </span>
          Verified purchase
        </p>
        <p className="mt-3 text-sm text-ink-900" data-id="element-183" data-mp="2fm36xl255t2a">
          <strong className="font-semibold" data-id="element-184" data-mp="2kn0obvfbuj2q">{purchase.name}</strong> from{' '}
          {purchase.city}
        </p>
        <p className="mt-1 text-xs text-ink-600" data-id="element-185" data-mp="2pm3sldnhgl9n">
          just bought{' '}
          <span className="font-semibold text-ink-800" data-id="element-186" data-mp="1rybtge4v79zf">{purchase.product}</span>
        </p>
      </div>
    </aside>;
}